/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const SET_LOCALE_OPTIONS = "SET_LOCALE_OPTIONS";